import React from 'react';
import { Button } from '../ui/Button';
import { Check, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-12 pb-16 md:pt-20 md:pb-24 px-4 bg-[#FDFCF8] overflow-hidden" data-id="element-114">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-115">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-900 px-4 py-1.5 rounded-full text-sm font-semibold mb-8 border border-amber-200" data-id="element-116">
          <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" data-id="element-117"></span>
          Oferta de lanzamiento — Precio especial + 3 bonos gratis
        </div>

        {/* H1 */}
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight text-stone-900 mb-6 leading-[1.1]" data-id="element-118">
          Tu semana de comida,{' '}
          <span className="text-emerald-800 italic" data-id="element-119">resuelta.</span>
        </h1>

        {/* H2 */}
        <h2 className="text-xl md:text-2xl text-stone-600 font-medium mb-4 max-w-2xl mx-auto" data-id="element-120">
          Menú + Lista + Swaps + Plan B — todo en un PDF descargable.
        </h2>

        {/* Microcopy */}
        <p className="text-stone-500 text-sm mb-10 flex items-center justify-center gap-4 flex-wrap" data-id="element-121">
          <span className="flex items-center gap-1" data-id="element-122">
            <Check className="w-4 h-4 text-emerald-600" data-id="element-123" /> Sin ingredientes
            raros
          </span>
          <span className="flex items-center gap-1" data-id="element-124">
            <Check className="w-4 h-4 text-emerald-600" data-id="element-125" /> Sin calculadora
          </span>
          <span className="flex items-center gap-1" data-id="element-126">
            <Check className="w-4 h-4 text-emerald-600" data-id="element-127" /> Descarga inmediata
          </span>
        </p>

        {/* CTA */}
        <div className="flex flex-col items-center gap-4 mb-12" data-id="element-128">
          <Button fullWidth className="md:w-auto text-lg px-10 py-5 shadow-xl shadow-stone-200" data-id="element-129">
            Quiero Semana Resuelta + Bonos Gratis
          </Button>
          <p className="text-xs text-stone-400 flex items-center gap-2" data-id="element-130">
            <span data-id="element-131">🔒 Pago seguro con MercadoPago</span>
            <span data-id="element-132">•</span>
            <span data-id="element-133">🛡️ Garantía 7 días</span>
          </p>
        </div>

        {/* Image Mockup */}
        <div className="relative mx-auto w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden" data-id="element-134">
          <img src="https://cdn.magicpatterns.com/uploads/pMDctvvkcchQaY47mk9kQF/Nmockup.png" alt="Semana Resuelta — PDF sobre mesada de cocina" className="w-full h-auto object-cover rounded-2xl" data-id="element-135" />
        </div>
      </div>
    </section>;
}